module.exports = __webpack_public_path__ + "39e4ef6ea6c67237a2ae63c38f05fd7f.svg";